import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import Step from "./Step";
import Icon from "./Icon";
import { VisibleText, VisuallyHiddenText } from "./Text";
var propTypes = {
  /** the 'active' step */
  active: PropTypes.bool,

  /** the 'visited' step(s) */
  visited: PropTypes.bool,

  /** switch to just dots when space is limited */
  condensed: PropTypes.bool,

  /** step item text */
  children: PropTypes.node
};
export default function NavStepperItem(_ref) {
  var active = _ref.active,
      visited = _ref.visited,
      condensed = _ref.condensed,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["active", "visited", "condensed", "children"]);

  var Text = condensed ? VisuallyHiddenText : VisibleText;
  return React.createElement(Step, Object.assign({
    active: active,
    visited: visited,
    condensed: condensed
  }, props), React.createElement(Text, {
    active: active ? 'true' : undefined
  }, children, React.createElement(Icon, {
    "aria-hidden": "true"
  })));
}
NavStepperItem.propTypes = propTypes;